// Show / hide password on any field wrapped with a [data-toggle-password] button.
$(document).on("click", "[data-toggle-password]", function () {
    var $input = $($(this).data("toggle-password"));
    var show = $input.attr("type") === "password";

    $input.attr("type", show ? "text" : "password");
    $(this)
        .attr("aria-pressed", show ? "true" : "false")
        .attr("aria-label", show ? "Hide password" : "Show password")
        .find("i").toggleClass("ti-eye", !show).toggleClass("ti-eye-off", show);
});
